import React, { Component } from 'react';
import { connect } from 'react-redux';
// constants
// utils
import { Translations, convertStringToArray } from '../../../utils';
// rest client
import { aemHostClient, eapiClient } from '../../../restClient';
// children
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../../common/Modal';
import AddUserSearchBox from '../AdminPanel/AddUserSearchBox/';
import ReactTable from '../AdminPanel/SubComp/Grid/Table/';
// action creator
import { setDarkTitleBarContent } from '../../layouts/actions/actionCreator';
import { setAdminTabIndex } from '../actions/actionCreator';
// style
import '../AdminPanel/SubComp/Grid/Table/index.css';
import './GroupDetail.css';

class GroupDetail extends Component {
  state = {
    displayUserData: [],
    showDeleteModal: false,
    groupName: this.props.group.group,
    status: this.props.group.status
  }

  translations = (text) => {
    return Translations(text, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  componentDidMount() {
    this.props.setDarkTitleBarTitle(this.props.group.group);
  }

  getSelectedUser = (selectedUser) => {
    if (!this.state.displayUserData.find(item => selectedUser.id === item.id)) {
      this.setState({ displayUserData: this.state.displayUserData.concat([selectedUser]).reverse() });
    }
  }

  componentWillMount() {
    eapiClient('/usergroup/' + this.props.group.id + '/users/')
      .then(({ data }) => {
        this.setState({
          displayUserData: data.responseData
        })
      });
    aemHostClient("/aemData/formData/json_group-detail")
      .then(({ data }) => {
        this.setState({ pageJson: data.par });
      });
    aemHostClient("/aemData/formData/json_dark-title-bar")
      .then(({ data }) => {
        this.setState({ darkTitleBarJson: data.par });
        document.title = `${Translations(data.par.static_text_darkTitleBar.groupMember, this.props.lang.currentLang.lang, this.props.lang.translatedData)} - ${'HSBC GLCM'}`
      });
    aemHostClient("/aemData/formData/json_group-admin")
      .then(({ data }) => {
        this.setState({ groupAdminPageJson: data.par });
      });
  }

  submit = () => {
    let payload = new SaveAndReturnPayload();
    payload.setPayload(this.state);
    var groupId = this.props.group.id;
    eapiClient("/usergroup/" + groupId, {
      method: 'PUT',
      data: JSON.stringify(payload.data)
    })
      .then(({ data }) => {
        this.props.setAdminTabIndex(1);
        this.props.history.push('/admin-panel/')
      });
  }

  deleteGroupData = () => {
    let payload = new DeleteAndReturnPayload();
    payload.setPayload(this.state);
    var groupId = this.props.group.id;
    eapiClient("/usergroup/" + groupId, {
      method: 'PUT',
      data: JSON.stringify(payload.data)
    })
      .then(({ data }) => {
        this.props.setAdminTabIndex(1);
        this.props.history.push('/admin-panel/')
      });
  }

  deleteGroup = () => {
    this.setState({
      showDeleteModal: true
    })
  }

  columnsHeader = () => {
    let optionsData;
    var options = this.translations(this.state.pageJson.table_groupMember.fieldLabels);
    var ids = this.state.pageJson.table_groupMember.fields;
    optionsData = convertStringToArray(options)
    let columns = []
    ids.map((item, index) => {
      columns.push({
        accessor: item,
        Header: optionsData[index],
        sortable: false
      })
    })
    return columns;
  }

  getInputValue = (e) => {
    this.setState({
      groupName: e.target.value
    })
  }

  toggleGroupDialog = () => {
    this.setState({
      showDeleteModal: false
    })
  }

  rowLink = (data) => {
    var userData = this.state.displayUserData.filter(id => {
      return id.id !== data.id
    })
    // let payload = new DeleteUsers();
    // payload.setPayload(this.state);
    // var groupId = this.props.group.id;;
    // eapiClient("/usergroup/" + groupId, {
    //   method: 'PUT',
    //   data: JSON.stringify(payload.data)
    // })
    // .then(({data}) => {
    //   this.setState({
    //     displayUserData: userData
    //   })
    // });
    this.setState({
      displayUserData: userData
    })
  }

  render() {
    const { groupName } = this.state
    return (this.state.pageJson !== undefined && this.state.groupAdminPageJson ? (
      <div className="group-detail">
        <div className="group-detail--section">
          <label className="group-lbl">{this.translations(this.state.pageJson.text_box_groupName.title)}</label>
          <input type="text" value={groupName} onChange={this.getInputValue} />
        </div>
        <div className="group-detail--section group-detail--border-none">
          <h1>{this.translations(this.state.pageJson.table_groupMember.title)}</h1>
          <label className="group-lbl">{this.translations(this.state.pageJson.table_groupMember.filterTitle)}</label>
          <AddUserSearchBox
            setSelectedOptions={this.getSelectedUser}
            userId={this.props.group.id}
          />
          <div className="gdoc-tab-tab-content">
            <ReactTable
              data={this.state.displayUserData}
              columns={this.columnsHeader()}
              noLink={(data) => this.rowLink(data)}
              lang={this.props.lang}
              pageJsonContent={this.state.pageJson.table_groupMember}
              isCaseList={true}
              defaultPageSize={5}
            />
          </div>
        </div>
        <div className="gdocs-clear-float"></div>
        <div className="group-detail--submit-section">
          <div className="form-buttons-wrapper">
            <button aria-label="Delete Group" className="gdocs-btn-delete" onClick={this.deleteGroup}>
              {this.translations(this.state.pageJson.button_deleteGroup.text)}
            </button>
            <Modal show={this.state.showDeleteModal} onClose={this.toggleGroupDialog} bsClass="delete-group-model">
              <ModalHeader title={this.translations(this.state.groupAdminPageJson.button_deleteGroup.text)} />
              <ModalBody>
                {this.translations(this.state.groupAdminPageJson.button_deleteGroup.descriptionText2)}
              </ModalBody>
              <ModalFooter>
                <div className="delete-group-model--body">
                  <div className="gdocs-float-left">
                    <button className="gdocs-btn-delete" onClick={this.toggleGroupDialog}> {this.translations(this.state.groupAdminPageJson.button_deleteGroup.donotDelete)}</button>
                  </div>
                  <div className="gdocs-float-right">
                    <button className="gdocs-btn-primary" onClick={this.deleteGroupData}>{this.translations(this.state.groupAdminPageJson.button_deleteGroup.text)}</button>
                  </div>
                </div>
              </ModalFooter>
            </Modal>
            <button aria-label="Add account" className="gdocs-btn-submit" onClick={this.submit}>
              {this.translations(this.state.pageJson.button_done.text)}
            </button>
          </div>
        </div>
      </div>
    ) : '');
  }
}

class DeleteAndReturnPayload {
  constructor() {
    this.data = {}
  }
  setPayload({ status }) {
    var deletedStatus = status.replace('active', 'delete')
    this.data = {
      status: deletedStatus
    }
  }
}

class SaveAndReturnPayload {
  constructor() {
    this.data = {};
  }
  setPayload({ groupName, displayUserData, status }) {
    var userData = displayUserData.map(item => item.id)
    this.data = {
      group: groupName,
      users: userData,
      status: status
    };
  }
}

// class DeleteUsers {
//   constructor(){
//     this.data = {};
//   }
//   setPayload({displayUserData}){
//     var userList = displayUserData.map(item => item.id)
//     this.data = {
//       userId: userList[0],
//       status: "urn:hsbc:cmb:gdocs:usergroups:taxonomies:status:delete",
//     }
//   }
// }

const mapStateToProps = state => {
  return {
    group: state.groupAdmin,
    lang: state.lang
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setDarkTitleBarTitle: pageTitle => {
      dispatch(setDarkTitleBarContent(pageTitle))
    },
    setAdminTabIndex: index => {
      dispatch(setAdminTabIndex(index))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupDetail)



// WEBPACK FOOTER //
// ./src/components/Admin/GroupDetail/GroupDetail.js